// extracted by mini-css-extract-plugin
module.exports = {"container":"amUwvS97"};